<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" content="商品详情"></el-page-header>
		<el-form label-position="right" :model="item" label-width="auto">
			<el-form-item label="商品名称" prop="name">
				<el-input v-model="item.name" placeholder="请输入商品名称"></el-input>
			</el-form-item>
			<el-form-item label="副标题">
				<el-input v-model="item.caption" placeholder="请输入副标题"></el-input>
			</el-form-item>
			<el-form-item label="是否上架">
				<el-switch v-model="item.is_marketable" active-color="#13ce66" inactive-color="#cccccc">
				</el-switch>
			</el-form-item>
			<el-form-item label="所属品牌">
				<el-select v-model="item.brand_id" filterable placeholder="请选择">
					<el-option v-for="item in brandList" :key="item.id"
						:label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="平台分类">
				<el-cascader v-model="item.product_category_id" placeholder="请选择" :options="adminCategoryList"
					:props="filterProps" clearable></el-cascader>
			</el-form-item>

			<el-form-item label="商品分类">
				<el-select v-if="item.suppliercategory" v-model="item.suppliercategory.name" filterable></el-select>
			</el-form-item>

			<el-form-item label="选择模板">
				<el-select v-model="item.industryTemplateName" filterable placeholder="请选择">
					<el-option v-for="item in industryTemplateList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item :label="list.itemKey" v-for="(list,index) in parameter">
				<el-input v-if="list.dataType == 1" v-model="list.itemValue" placeholder="请输入参数"></el-input>
				<el-date-picker v-else-if="list.dataType == 2" v-model="list.itemValue" type="date" placeholder="选择日期">
				</el-date-picker>
				<el-date-picker v-else-if="list.dataType == 3" v-model="list.itemValue" type="datetime"
					placeholder="选择日期时间">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="商品编码">
				<el-input v-model="item.sku_no" placeholder="请输入商品编码"></el-input>
			</el-form-item>
			<!-- <el-input v-model="item.caption" placeholder="请输入商品规格"></el-input> -->
			<div>
				<div class="goods-spec">
					<el-link type="primary" @click="addPrivateSpec" class="goods-spec-add" style="">添加规格</el-link>
				</div>
				<div class="goods-container" v-for="(attr, index) in privateGoodsItem" :key="index">
					<div class="goods-content">
						<div class="goods-content-box">
							<div class="goods-content-left">
								<el-form-item label="规格名">
									<el-input v-model="attr.privateSpecName" placeholder="请输入规格名"></el-input>
								</el-form-item>
								<el-form-item label="规格值">
									<el-tag v-for="tag in attr.dynamicTags" :key="tag" closable
										:disable-transitions="false" @close="handleClose(tag, attr)">
										{{tag}}
									</el-tag>
									<el-input class="input-new-tag" v-if="attr.inputVisible" v-model="attr.inputValue"
										:ref="`saveTagInput${index}`" size="small"
										@keyup.enter.native="handleInputConfirm(attr.inputValue, attr)"
										@blur="handleInputConfirm(attr.inputValue, attr)"></el-input>
									<el-button v-else class="button-new-tag" size="small"
										@click="showInput(attr, index)" style="display: none;">+ 添加</el-button>
								</el-form-item>
							</div>
							<div class="goods-content-right">
								<el-link type="danger" @click="delPrivateSpec(index)">删除规格</el-link>
							</div>
						</div>
					</div>
				</div>
				<!-- <p style="margin:22px 0 10px 0">价格</p> -->
				<el-table style="margin-bottom: 22px; margin-top:0;" ref="multipleTable"
					:data="tableColumnList.tableBodyList" border tooltip-effect="dark">
					<el-table-column :label="item.propName" :property="item.prop"
						v-for="item in tableColumnList.tableHeaderList" :key="item.prop" align="center">
						<template slot-scope="scope">
							<span>{{ scope.row[scope.column.property] }}</span>
						</template>
					</el-table-column>
					<el-table-column label="图片">
						<template slot-scope="scope">
							<el-upload
									class="single-image single-image-small"
									list-type="single-image"
									:on-success="(value) => uploadSuccess1('product_image', 'single', value, scope.$index)"
									:show-file-list="false"
									:action="app_url + '/store/uploader/upload'">
								<i class="icon el-icon-plus" v-if="!tableColumnList.tableBodyList[scope.$index].product_image"></i>
								<img :src="tableColumnList.tableBodyList[scope.$index].product_image" v-else>
							</el-upload>
						</template>
					</el-table-column>
					<el-table-column label="销售价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.price"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="成本价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.cost"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="市场价（元）">
						<template slot-scope="scope">
							<el-input v-model="scope.row.marketPrice"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="Sku编码">
						<template slot-scope="scope">
							<el-input v-model="scope.row.product_sku_no"></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<el-form-item label="商品主图" prop="product_pic_main">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('product_pic_main', 'single', value)"
						:show-file-list="false"
						:action="app_url + '/admin/uploader/upload'">
					<i class="icon el-icon-plus" v-if="!item.product_pic_main"></i>
					<img :src="item.product_pic_main" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="细节图" prop="product_images">
				<div>
					<ul class="el-upload-list el-upload-list--picture-card">
						<li :tabindex="index" class="el-upload-list__item is-success" v-for="(src, index) in item.product_images" :key="index">
							<img :src="src" alt="" class="el-upload-list__item-thumbnail">
							<label class="el-upload-list__item-status-label">
								<i class="el-icon-upload-success el-icon-check"></i>
							</label>
							<i class="el-icon-close"></i><i class="el-icon-close-tip">按 delete 键可删除</i>
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview">
									<i class="el-icon-zoom-in"></i></span>
								<span class="el-upload-list__item-delete" @click="delectImage('product_images', index)">
									<i class="el-icon-delete"></i>
								</span>
							</span>
						</li>
					</ul>
					<el-upload
							style="display: inline"
							:multiple="true"
							:limit="10 - item.product_images.length"
							:action="app_url + '/admin/uploader/upload'"
							list-type="picture-card"
							:show-file-list="false"
							:on-success="(value) => uploadSuccess('product_images', 'multi', value)">
						<i class="el-icon-plus"></i>
					</el-upload>
				</div>
			</el-form-item>

			<el-form-item label="商品详情" id="quill-upload">
				<el-upload :action="app_url + '/admin/uploader/upload'" :show-file-list="false" :on-success="editorSuccess"
					:on-error="uploadError" style="display: none;">
				</el-upload>
				<quill-editor ref="quill" v-model="item.introduction" :options="editorOption" />
			</el-form-item>

			<el-form-item label="审核状态">
				<el-radio v-model="authStatus" :label="1" @change="auditPass">通过</el-radio>
				<el-radio v-model="authStatus" :label="2">驳回</el-radio>
			</el-form-item>
			<el-form-item label="驳回理由" v-if="authStatus == 2">
				<el-input v-model="memo" placeholder="请输入驳回理由" class="el-input-default-width-220"></el-input>
				<el-button style="margin-left: 15px;" size="big" type="primary" @click="auditRefuse">驳回</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		quillEditor
	} from 'vue-quill-editor'
	export default {
		data() {
			return {
				item: {
					product_pic_main: '',
					product_images: [],
					supplier_category_id: 0
				},
				isLoad: false,
				id: this.$route.query.id,
				canEdit: this.$route.query.op && this.$route.query.op==1 ? true : false,
				productImages: [],
				productPicMain: [],
				radio: "",
				brandList: [], // 品牌列表
				adminCategoryList: [], // 平台商品分类列表
				industryTemplateList: [], // 行业模板
				parameter: [],
				memo: '',
                authStatus: 0,

				tableColumnList: {
					tableHeaderList: [],
					tableBodyList: []
				},
				privateGoodsItem: [],
				// 方法的变量
				goods_option: [],
				filterProps: {
					value: 'id',
					label: 'name',
					emitPath: false,
					checkStrictly: true
				},
				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'],
								['blockquote', 'code-block'],
								[{
									'header': 1
								}, {
									'header': 2
								}],
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}],
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}],
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}],
								[{
									'direction': 'rtl'
								}],
								[{
									'size': ['small', false, 'large', 'huge']
								}],
								[{
									'header': [1, 2, 3, 4, 5, 6, false]
								}],
								[{
									'color': []
								}, {
									'background': []
								}],
								[{
									'font': []
								}],
								[{
									'align': []
								}],
								['clean'],
								['image', 'video']
							],
							handlers: {
								image: function(value) {
									if (value)
										document.querySelector('#quill-upload input').click()
									else
										this.quill.format('image', false);
								}
							}
						}
					},
				}
			}
		},
		created() {
			this.loadData()
		},
		computed: {
			calculateAttribute() {
				let obj = {}
				this.privateGoodsItem.forEach((item) => {
					if (item.privateSpecName) {
						obj[item.privateSpecName] = item.dynamicTags
					}
				})
				return obj
			}
		},
		watch: {
			calculateAttribute(newVal) {
				let cloneNewVal = JSON.parse(JSON.stringify(newVal))
				let attrName = []
				let attrValue = []
				for (let key in cloneNewVal) {
					attrName.push(key)
					attrValue.push(cloneNewVal[key])
				}
				let finalArr = this.cartesianProductOf(...attrValue)
				let tableObj = {
					tableBodyList: [],
					tableHeaderList: []
				}
				tableObj.tableBodyList = finalArr.map((item) => {
					let obj = {
						id: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].id : '',
						price: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].price : '',
						marketPrice: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].marketPrice : '',
						cost: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].cost : '',
						product_image: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].product_image : '',
						product_sku_no: this.goods_option[item.join('|')] ? this.goods_option[item.join('|')].product_sku_no : ''
					}
					for (let i = 0; i < item.length; i++) {
						obj[attrName[i]] = item[i]
					}
					return obj
				})
				this.tableColumnList.tableBodyList = tableObj.tableBodyList
				let skuTableArr = Object.keys(newVal)
				tableObj.tableHeaderList = skuTableArr.map((item) => {
					return {
						prop: item,
						propName: item
					}
				})
				this.tableColumnList.tableHeaderList = tableObj.tableHeaderList
			}
		},
		methods: {
            auditPass() {
				let that = this;

				// 解析SKU
				let sku = [];
				this.tableColumnList.tableBodyList.forEach((item) => {
					let obj = {}
					obj.price = item.price;
					obj.skuId = item.id;
					let skuName = '';
					this.tableColumnList.tableHeaderList.forEach((i) => {
						if (skuName != '') {
							skuName += ',';
						}
						skuName += item[i.propName];
					})
					obj.skuName = skuName;

					sku.push(obj);
				})

				if (this.item.store_id > 0) {
					this.$confirm('确认审核通过？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'info'
					}).then(() => {
						this.axios.post('/admin/product/auth', {
							id: this.id,
							authStatus: 1,
							platform_add_price: 0,
							skuUpdatePriceList:sku
						}).then(() => {
							this.$message.success({
								message: '操作成功'
							});
							this.goBack()
						})
					})
				} else {
					this.$prompt('确认加价金额', '确认审核', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						inputPattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
						inputErrorMessage: '加价金额不对'
					}).then(({ value }) => {
						this.axios.post('/admin/product/auth', {
							id: this.id,
							authStatus: 1,
							platform_add_price: value,
							skuUpdatePriceList:sku
						}).then(() => {
							this.$message.success({
								message: '操作成功'
							});
							this.goBack()
						})
					}).catch(() => {
						this.authStatus = ''
					});
				}




            },
            auditRefuse() {
                if(this.memo==''){
					this.$alert('请输入驳回理由');
					return;
				}
				this.axios.post('/admin/product/auth', {
					id: this.id,
					authStatus: 2,
					memo: this.memo
				}).then(() => {
					this.$message.success({
						message: '操作成功'
					});
					this.goBack()
				})
            },
			loadData: async function() {
				// 中控：商品分类树
				await this.axios.get('/admin/data/getCategoryTreeAdmin', {
				}).then(res => {
					this.adminCategoryList = res.data.list
				})

				// 品牌列表
				await this.axios.get('/admin/data/listBrandForSelect', {
				}).then(res => {
					this.brandList = res.data.list
				})

				// 获取商品信息
				await this.axios.get('/admin/product/detail', {
					params: {
						id: this.id
					}
				}).then(res => {
					if(res.data.detail.specifications){
						res.data.detail.specifications.forEach(key => {
							key.specValue = key.specValue.split(',')
							key.inputVisible = false
							key.inputValue = ''
						})

						res.data.detail.specifications.forEach((key, index) => {
							this.$set(key, 'dynamicTags', key.specValue)
							this.$set(key, 'privateSpecName', key.specName)
							this.tableColumnList.tableHeaderList[index] = {}
							this.$set(this.tableColumnList.tableHeaderList[index], 'propName', key.specName)
							this.$set(this.tableColumnList.tableHeaderList[index], 'prop', key.specName)
						})
						this.privateGoodsItem = res.data.detail.specifications
					}

					res.data.detail.sku.forEach((key, index) => {
						let skuName1 = key.sku_name.split(',')
						let skuNameArr = ''
						for (let i = 0; i < skuName1.length; i++) {
							skuNameArr += skuName1[i] + '|'
						}
						skuNameArr = skuNameArr.substr(0, skuNameArr.length - 1)
						let obj = {
							id: key.id,
							price: key.price,
							marketPrice: key.market_price,
							cost: key.cost,
							product_image: key.product_image,
							product_sku_no: key.product_sku_no
						}
						this.goods_option[skuNameArr] = obj
					})

					this.item = res.data.detail
					this.item.is_marketable = this.item.is_marketable.toString()
					this.$forceUpdate()
				})
			},
			// 后退一步
			goBack() {
				// this.$router.back(-1)
				var link =  this.$router.resolve({
				    path: '/GoodsAudit/supplierGoods.html',
				    query: {
						page: this.$route.query.page
				    }
				});
				window.open(link.href, '_self')
			},
			addPrivateSpec() {
				this.privateGoodsItem.push({
					privateSpecName: '',
					dynamicTags: [],
					inputVisible: false,
					inputValue: ''
				})
			},
			delPrivateSpec(index) {
				this.privateGoodsItem.splice(index, 1)
			},
			handleInputConfirm(val, attr) {
				if (val)
					attr.dynamicTags.push(val)
				attr.inputVisible = false
				attr.inputValue = ''
			},
			handleClose(tag, item) {
				item.dynamicTags.splice(item.dynamicTags.indexOf(tag), 1)
			},
			showInput(attr, index) {
				attr.inputVisible = true
				this.$nextTick(() => {
					this.$refs[`saveTagInput${index}`][0].$refs.input.focus()
				})
			},
			// 规格交叉
			cartesianProductOf(...args) {
				return args.reduce((total, current) => {
					let ret = []
					total.forEach((a) => {
						current.forEach((b) => {
							ret.push(a.concat([b]))
						})
					})
					return ret
				}, [
					[]
				])
			},
			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
				}
				return extension;
			},
			uploadSuccess(key, model, res, file) {
				if (model == 'single') {
					this.item[key] = res.data.fileInfo.external_url
				} else {
					this.item[key].push(res.data.fileInfo.external_url)
				}

			},
			delectImage: function (key, index) {
				this.item[key].splice(index, 1)
			},
			editorSuccess(res) {
				let quill = this.$refs.quill.quill
				let length = quill.getSelection().index
				// 上传图片的路径
				quill.insertEmbed(length, 'image', res.data.fileInfo.external_url)
				quill.setSelection(length + 1)
				this.$message.success({
					message: '上传成功'
				});
			}
		},
		components: {
			quillEditor
		}
	}
</script>
<style scoped>
	.goods-spec {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.goods-spec .goods-spec-add {
		margin-left: 30px;
		margin-bottom: 14px;
	}

	.goods-container .button-new-tag {
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.goods-container .input-new-tag {
		width: 90px;
		margin-right: 10px;
		vertical-align: bottom;
	}

	.goods-container .el-tag {
		margin-right: 10px;
	}

	.goods-container .goods-content {
		margin-bottom: 10px;
		padding: 14px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		background-color: #fcfcfc;
	}

	.goods-content .goods-content-box {
		display: flex;
		align-items: center;
	}

	.goods-content-box .goods-content-left {
		flex: 1;
	}
</style>
